"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonsItem = void 0;
const DateOfBirth_1 = require("./persons/DateOfBirth");
const FirstName_1 = require("./persons/FirstName");
const HomeAddress_1 = require("./persons/HomeAddress");
const LastName_1 = require("./persons/LastName");
const PersonId_1 = require("./persons/PersonId");
const PersonRole_1 = require("./persons/PersonRole");
exports.PersonsItem = {
    date_of_birth: DateOfBirth_1.DateOfBirth,
    first_name: FirstName_1.FirstName,
    home_address: HomeAddress_1.HomeAddress,
    last_name: LastName_1.LastName,
    person_id: PersonId_1.PersonId,
    person_role: PersonRole_1.PersonRole,
};
